(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["assortment-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jfab-assortment')) {
    class JFabAssortment extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized=true;
        this.form=this.closest('form');
        this.productMedia=this.closest('section')?.querySelector('[data-assortment-product-media]');
        this.copy=this.querySelector('[data-assortment-copy]').dataset;
        this.previewHeading=this.querySelector('[data-assortment-preview-heading]').textContent;
        this.mount=this.querySelector('[data-assortment-personalization]');
        this.svg=this.querySelector('[data-assortment-svg]');
        this.warning=this.querySelector('[data-assortment-warning]');
        this.status=this.querySelector('[data-assortment-status]');
        this.submit=this.querySelector('[data-assortment-submit]');
        this.side=this.querySelector('[data-assortment-side]');
        this.clear=this.querySelector('[data-assortment-clear]');
        this.demo=this.hasAttribute('data-demo');
        this.state=new Map();
        try {
          this.catalog=JSON.parse(this.querySelector('[data-assortment-data]').textContent);
          const expansion=JSON.parse(this.querySelector('[data-assortment-expansion-data]')?.textContent||'[]');
          this.catalog=this.catalog.concat(expansion);
          if(this.hasAttribute('data-builder-only')) this.catalog=this.catalog.filter(item=>item.kind==='builder');
          this.variants=JSON.parse(this.querySelector('[data-assortment-variants]').textContent)||[];
          this.optionNames=JSON.parse(this.querySelector('[data-assortment-option-names]').textContent)||[];
        } catch { this.status.textContent=this.copy.invalid; return; }
        if (!this.form || !Array.isArray(this.catalog)) return;
        this.form.addEventListener('submit',event=>{
          if(this.adding) {event.preventDefault();event.stopImmediatePropagation();return;}
          this.sync();
          if(this.demo || !this.sellable || this.blocked || !this.form.checkValidity()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.form.reportValidity();
          } else if(this.item.kind==='blank') {
            event.preventDefault();event.stopImmediatePropagation();this.addBlankBatch();
          }
        },true);
        this.form.addEventListener('input',()=>{this.paint();this.review();this.refreshProductMedia();});
        this.form.addEventListener('change',()=>{this.sync();this.review();this.refreshProductMedia();});
        this.side.addEventListener('change',()=>{this.paint();this.refreshProductMedia();});
        this.clear.addEventListener('click',()=>{
          this.textControls.filter(x=>x.side==='back').forEach(x=>{x.input.value='';this.current.text[x.label]='';});
          this.paint();this.review();this.refreshProductMedia();
        });
        if(this.demo) this.departments();
        else {
          const item=this.catalog.find(x=>x.handle===this.dataset.handle);
          if(item) this.selectProduct(item); else this.status.textContent=this.copy.invalid;
        }
      }
      departments() {
        const groups=[...new Set(this.catalog.map(x=>x.group))];
        const nav=this.querySelector('[data-assortment-departments]');
        groups.forEach(group=>{
          const button=document.createElement('button'); button.type='button';button.textContent=group;
          button.addEventListener('click',()=>{
            [...nav.children].forEach(x=>x.setAttribute('aria-pressed',String(x===button)));
            this.productList(group);
          });
          nav.append(button);
        });
        const wanted=new URLSearchParams(window.location.search).get('group');
        const chosen=[...nav.children].find(x=>x.textContent===wanted)||nav.firstElementChild;chosen.click();
      }
      productList(group) {
        const list=this.querySelector('[data-assortment-list]');list.replaceChildren();
        this.catalog.filter(x=>x.group===group).forEach(item=>{
          const button=document.createElement('button');button.type='button';button.textContent=item.title;
          button.addEventListener('click',()=>{
            [...list.children].forEach(x=>x.setAttribute('aria-pressed',String(x===button)));
            this.selectProduct(item);
          });
          list.append(button);
        });
        list.firstElementChild.click();
      }
      field(label,values,parent,name) {
        const wrap=document.createElement('label');const text=document.createElement('span');text.textContent=label;
        const select=document.createElement('select');select.name=`properties[${name||label}]`;
        values.forEach(value=>select.add(new Option(value,value)));
        wrap.append(text,select);parent.append(wrap);return select;
      }
      selectProduct(item) {
        this.item=item;this.current=this.state.get(item.key)||{text:{},options:{},font:'Block',side:'front'};
        if(!this.demo&&!this.state.has(item.key)) {
          const initial=this.variants.find(v=>String(v.id)===this.form.querySelector('input[name="id"]')?.value);
          if(initial)this.optionNames.forEach((name,index)=>{
            const value=initial.options[index];
            if(item.kind==='blank'&&name==='Material and holes') {
              const split=value.lastIndexOf(' · ');
              if(split>=0){this.current.options.Material=value.slice(0,split);this.current.options['Hole option']=value.slice(split+3);}
            } else this.current.options[name]=value;
          });
        }
        this.state.set(item.key,this.current);
        this.querySelector('[data-assortment-title]').textContent=item.title;
        this.querySelector('[data-assortment-description]').textContent=item.description;
        const options=this.querySelector('[data-assortment-options]');options.replaceChildren();
        this.selects=[];
        const itemOptions=item.kind==='blank'&&item.blank_options?item.blank_options:item.options;
        for(const [label,sourceValues] of [[this.copy.size,item.sizes.map(x=>x.label)],...Object.entries(itemOptions)]) {
          const values=item.kind==='blank'&&label==='Pack quantity'?['25','50','100','150','200']:sourceValues;
          const select=this.field(label,values,options);
          select.value=values.includes(this.current.options[label])?this.current.options[label]:values[0];
          this.selects.push({label,select});
        }
        const quantity=this.form.querySelector('input[name="quantity"]');
        if(quantity) {
          const label=quantity.closest('label');
          if(label) label.hidden=item.kind==='blank';
          if(item.kind==='blank') quantity.value='1';
        }
        this.classList.toggle('assortment--blank',item.kind==='blank');
        const review=this.querySelector('.assortment__review');
        review.hidden=item.kind==='blank';
        if(item.kind==='blank') options.after(this.submit);
        else review.before(this.submit);
        this.mount.replaceChildren();this.textControls=[];this.font=null;this.blocked=false;
        const engraved=['pet','business','plate'].includes(item.kind);
        this.querySelector('[data-assortment-proof]').hidden=!engraved||item.kind==='plate';
        this.querySelector('[data-assortment-preview]').hidden=item.kind==='plate'||(item.kind==='blank'&&!!this.productMedia?.querySelector('img'));
        this.querySelector('[data-assortment-layout-note]').hidden=item.kind!=='blank';
        this.querySelector('[data-assortment-preview-heading]').textContent=item.kind==='blank'?this.copy.layoutPreview:this.previewHeading;
        this.querySelector('[data-assortment-side-label]').hidden=!['pet','business'].includes(item.kind);
        this.side.value=this.current.side;
        this.plate=null;
        if(item.kind==='plate') {
          const layouts={};
          item.sizes.forEach((s,index)=>{layouts[String(index)]={name:item.title+' — '+s.label,width_mm:s.width_mm,height_mm:s.height_mm,lines:Array.from({length:s.lines},()=>({labels:item.labels,max_characters:40}))};});
          const fragment=this.querySelector('[data-assortment-plate-template]').content.cloneNode(true);
          fragment.querySelector('[data-engraving-layouts]').textContent=JSON.stringify(layouts);
          this.querySelector('[data-engraving-layout-choice]').value=String(this.sizeIndex());
          this.mount.append(fragment);this.plate=this.mount.querySelector('jfab-engraving-lines');
          if(this.current.plateEntries && this.plate.entries) {this.plate.entries=this.current.plateEntries;this.plate.activeKey=null;this.plate.syncLayout();}
        } else if(engraved) {
          this.font=this.field(this.copy.font,['Block','Serif','Monospace'],this.mount,'Font');this.font.value=this.current.font;
          for(const side of ['front','back']) {
            const group=document.createElement('fieldset');group.className='assortment__fields';
            const legend=document.createElement('legend');legend.textContent=this.copy[side];group.append(legend);
            (item[side+'_fields']||[]).forEach(label=>{
              const wrap=document.createElement('label');const span=document.createElement('span');span.textContent=label;
              const input=document.createElement('input');input.type='text';input.name=`properties[${side==='back'?'Back — ':''}${label}]`;
              input.value=this.current.text[label]||'';input.autocomplete='off';input.maxLength=item.kind==='business'?100:40;
              input.required=side==='front'&&label===item.front_fields[0];
              wrap.append(span,input);group.append(wrap);this.textControls.push({label,input,side});
            });
            this.mount.append(group);
          }
          if(item.kind==='business') {
            const wrap=document.createElement('label');wrap.textContent=this.copy.artwork;
            const input=document.createElement('input');input.type='file';input.name='properties[Artwork]';input.accept='.png,.jpg,.jpeg,.svg,.pdf';wrap.append(input);this.mount.append(wrap);
            this.form.enctype='multipart/form-data';
          }
        }
        if(engraved&&item.kind!=='plate') {
          const wrap=document.createElement('label');wrap.textContent=this.copy.email;
          const input=document.createElement('input');input.type='email';input.autocomplete='email';input.name='properties[Proof email]';input.required=!this.demo;input.disabled=this.demo;
          input.value=this.current.email||'';input.addEventListener('input',()=>{this.current.email=input.value;});
          wrap.append(input);this.mount.append(wrap);
        }
        this.mediaObserver?.disconnect();
        if(this.productMedia) {
          this.mediaObserver=new MutationObserver(()=>this.refreshProductMedia());
          this.mediaObserver.observe(this.plate?.querySelector('[data-engraving-svg]')||this.svg,{childList:true,subtree:true,attributes:true,characterData:true});
        }
        this.sync();
      }
      sizeIndex() {return Math.max(0,this.item.sizes.findIndex(x=>x.label===this.selects[0].select.value));}
      sync() {
        if(!this.item) return;
        this.selects.forEach(({label,select})=>{this.current.options[label]=select.value;});
        const index=this.sizeIndex();
        this.querySelector('[data-engraving-layout-choice]').value=String(index);
        if(this.plate) {this.plate.dataset.mounting=this.current.options.Mounting||'No holes';this.plate.syncLayout?.();this.plate.paint?.();this.current.plateEntries=this.plate.entries;}
        const optionNames=this.demo?this.item.price_options:this.optionNames;
        const selected=optionNames.map(name=>this.selects.find(x=>x.label===name)?.select.value);
        const variants=this.demo?this.item.price_variants:this.variants;
        this.variant=variants.find(v=>JSON.stringify(v.options)===JSON.stringify(selected));
        this.packItems=null;
        const summary=this.querySelector('[data-assortment-pack-summary]');summary.hidden=true;
        if(this.item.kind==='blank') {
          const material=this.current.options.Material;
          const hole=this.current.options['Hole option'];
          const materialIndex=optionNames.indexOf('Material');
          const holeIndex=optionNames.indexOf('Hole option');
          const combinedIndex=optionNames.indexOf('Material and holes');
          if(combinedIndex>=0) selected[combinedIndex]=`${material} · ${hole}`;
          const legacyMaterial=this.item.legacy_material;
          const materialSupported=combinedIndex>=0||materialIndex>=0||material===legacyMaterial;
          const holeSupported=combinedIndex>=0||holeIndex>=0||hole===this.item.legacy_hole;
          const packIndex=optionNames.indexOf('Pack quantity');
          const count=Number(selected[packIndex]);
          const packs=Number.isSafeInteger(count)&&count>0?[[count,1]]:[];
          this.packItems=packIndex<0?[]:packs.map(([pack,quantity])=>{
            const match=selected.slice();match[packIndex]=String(pack);
            return {variant:variants.find(v=>JSON.stringify(v.options)===JSON.stringify(match)),quantity};
          });
          const valid=materialSupported&&holeSupported&&this.packItems.length>0&&this.packItems.every(x=>x.variant&&x.variant.price>0);
          this.variant=valid?{id:this.packItems[0].variant.id,price:this.packItems.reduce((sum,x)=>sum+x.variant.price*x.quantity,0),available:this.packItems.every(x=>x.variant.available)}:null;
          summary.hidden=false;summary.textContent=this.copy.packSummary.replace('{count}',count).replace('{breakdown}',packs.map(([pack,quantity])=>`${quantity} × ${pack}`).join(' + '));
          if(valid) {
            const each=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.form.dataset.currency||'USD'}).format(this.variant.price/100/count);
            summary.textContent+=' · '+this.copy.unitPrice.replace('{price}',each);
          }
        }
        const id=this.form.querySelector('input[name="id"]');if(id)id.value=this.variant?.id||'';
        this.sellable=!this.demo&&!!this.variant&&this.variant.available&&this.variant.price>0;
        this.submit.hidden=this.demo;
        this.submit.disabled=!this.sellable;
        this.submit.textContent=this.variant&&!this.variant.available&&!this.demo?this.copy.sold:this.copy.cart;
        this.status.textContent=this.sellable||this.demo?'':this.variant&&!this.variant.available?this.copy.sold:this.item.kind==='blank'?this.copy.materialPending:this.copy.pending;
        const price=this.form.querySelector('[data-assortment-price]');
        if(price) price.textContent=this.variant?.price>0?new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.form.dataset.currency||'USD'}).format(this.variant.price/100):this.copy.pending;
        this.paint();this.review();this.refreshProductMedia();
      }
      async addBlankBatch() {
        if(!this.sellable||!this.packItems?.length)return;
        const items=this.packItems.map(({variant,quantity})=>({id:variant.id,quantity}));
        if(items.some(x=>!Number.isSafeInteger(x.quantity)))return;
        this.adding=true;this.submit.disabled=true;this.status.textContent=this.copy.adding;
        try {
          const root=window.Shopify?.routes?.root||'/';
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          if(!response.ok) {
            let message=this.copy.cartError;
            try {
              const result=await response.json();
              if(typeof result.description==='string'&&result.description.trim())message=result.description;
            } catch {}
            this.status.textContent=message;
            return;
          }
          this.status.textContent=this.copy.cartSuccess;
          window.location.assign(root+'cart');
        } catch {
          this.status.textContent=this.copy.cartError;
        } finally {
          this.adding=false;this.submit.disabled=!this.sellable;
        }
      }
      refreshProductMedia() {
        if(!this.productMedia)return;
        if(this.item?.kind==='blank'&&this.productMedia.querySelector('img')) {
          const materialMatches=!this.item.media_material||this.current.options.Material===this.item.media_material;
          const holeMatches=!this.item.media_hole||this.current.options['Hole option']===this.item.media_hole;
          this.productMedia.hidden=!(materialMatches&&holeMatches);
          this.querySelector('[data-assortment-preview]').hidden=!this.item.preview_profiles;
          return;
        }
        const original=this.plate?.querySelector('[data-engraving-svg]')||this.svg;
        if(!original||original.hidden||!original.childElementCount)return;
        const preview=original.cloneNode(true);
        preview.removeAttribute('data-engraving-svg');preview.removeAttribute('data-assortment-svg');
        this.productMedia.replaceChildren(preview);
      }
      el(tag,attrs={}) {
        const n=document.createElementNS('http://www.w3.org/2000/svg',tag);Object.entries(attrs).forEach(([k,v])=>n.setAttribute(k,v));return n;
      }
      paint() {
        if(!this.item||this.item.kind==='plate')return;
        const item=this.item;const size=item.sizes[this.sizeIndex()];
        const both=this.current.options['Engraved sides']==='Front and back';
        const backEntries=this.textControls.filter(x=>x.side==='back'&&x.input.value.trim());
        this.textControls.forEach(x=>{this.current.text[x.label]=x.input.value; x.input.disabled=x.side==='back'&&!both;x.input.setCustomValidity('');});
        this.current.font=this.font?.value||'Block';this.current.side=this.side.value;
        this.side.options[1].disabled=!both;
        if(!both)this.side.value='front';
        const width=size.width_mm||60,height=size.height_mm;
        this.svg.replaceChildren();this.svg.setAttribute('viewBox',`-5 -5 ${width+10} ${height+10}`);
        this.querySelector('[data-assortment-size]').textContent=size.label+(item.dimension_basis?' · '+item.dimension_basis:'');
        const attrs={fill:'#e5e9eb',stroke:'#435d6a','stroke-width':.4};
        if(item.kind==='blank'&&item.preview_profiles) {
          const profile=item.preview_profiles.find(p=>p.size===size.label&&p.hole===this.current.options['Hole option']);
          this.svg.hidden=!profile;this.warning.hidden=true;this.clear.hidden=true;this.blocked=false;
          if(!profile)return;
          const material=Object.keys(item.materials||{}).find(key=>item.materials[key]===this.current.options.Material)||this.current.options.Material;
          const fill=material==='Brass'?'#c6a660':material?.startsWith('Aluminum')?'#dce0e2':attrs.fill;
          this.svg.append(this.el('path',{d:profile.path,...attrs,fill}));
          for(const [cx,cy] of profile.holes)this.svg.append(this.el('circle',{cx,cy,r:profile.hole_diameter/2,fill:'#f3f5f6',stroke:'#435d6a','stroke-width':.3,'data-mounting-hole':''}));
          for(const slot of profile.slots||[])this.svg.append(this.el('rect',{x:slot.x,y:slot.y,width:slot.width,height:slot.height,rx:slot.radius,fill:'#f3f5f6',stroke:'#435d6a','stroke-width':.3,'data-collar-slot':''}));
          this.svg.setAttribute('aria-label',`${item.title} · ${size.label} · ${material} · ${this.current.options['Hole option']}`);
          return;
        }
        let outline;
        if(item.shape==='circle') outline=this.el('circle',{cx:width/2,cy:height/2,r:width/2,...attrs});
        else if(item.shape==='round') outline=this.el('ellipse',{cx:width/2,cy:height/2,rx:width/2,ry:height/2,...attrs});
        else if(item.shape==='bone') outline=this.el('path',{d:`M ${width*.28} ${height*.25} C ${width*.28} 0,0 0,0 ${height*.25} Q 0 ${height*.4},${width*.08} ${height*.5} Q 0 ${height*.6},0 ${height*.75} C 0 ${height},${width*.28} ${height},${width*.28} ${height*.75} L ${width*.72} ${height*.75} C ${width*.72} ${height},${width} ${height},${width} ${height*.75} Q ${width} ${height*.6},${width*.92} ${height*.5} Q ${width} ${height*.4},${width} ${height*.25} C ${width} 0,${width*.72} 0,${width*.72} ${height*.25} Z`,...attrs});
        else if(item.shape==='heart') outline=this.el('path',{d:`M ${width/2} ${height*.22} C ${width*.22} 0,0 0,0 ${height*.28} C 0 ${height*.6},${width*.35} ${height*.82},${width/2} ${height} C ${width*.65} ${height*.82},${width} ${height*.6},${width} ${height*.28} C ${width} 0,${width*.78} 0,${width/2} ${height*.22} Z`,...attrs});
        else if(item.shape.startsWith('triangle')) outline=this.el('path',{d:`M 0 0 L ${width} ${height} L 0 ${height} Z`,...attrs});
        else if(item.kind==='builder'&&item.shape==='tab') {
          this.svg.hidden=true;this.warning.hidden=true;this.clear.hidden=true;return;
        } else outline=this.el('rect',{x:0,y:0,width,height,rx:item.shape==='dog'?width*.25:1,...attrs});
        this.svg.hidden=false;this.svg.append(outline);
        const mounting=this.current.options.Mounting||this.current.options['Hole option']||'';
        const hole=(x,y)=>this.svg.append(this.el('circle',{cx:x,cy:y,r:Math.min(width,height)*.045,fill:'#f3f5f6',stroke:'#435d6a','stroke-width':.3,'data-mounting-hole':''}));
        if(mounting==='Two end holes'){hole(width*.07,height/2);hole(width*.93,height/2);}
        else if(mounting==='Four corner holes'){for(const x of [.07,.93])for(const y of [.14,.86])hole(width*x,height*y);}
        else if(mounting==='One hole'||item.kind==='pet'||['round-pet-tag-blanks','bone-pet-tag-blanks','heart-pet-tag-blanks'].includes(item.key))hole(item.shape==='bone'?width*.16:item.shape==='heart'?width*.3:width/2,item.shape==='bone'?height*.5:item.shape==='heart'?height*.18:height*.12);
        if(item.shape==='triangle-cutout')this.svg.append(this.el('path',{d:`M ${width*.23} ${height*.5} L ${width*.55} ${height*.82} L ${width*.23} ${height*.82} Z`,fill:'#f3f5f6',stroke:'#435d6a','stroke-width':.4}));
        const active=this.textControls.filter(x=>x.side===this.side.value&&!x.input.disabled);
        const allEnabled=this.textControls.filter(x=>!x.input.disabled);let wide=false;
        allEnabled.forEach(entry=>{
          const matching=allEnabled.filter(x=>x.side===entry.side),total=matching.length,index=matching.indexOf(entry);
          const nominal=Math.min(height*.1,width*.075,(height*.52)/total);
          const text=this.el('text',{x:width/2,y:height*.3+(index+.5)*height*.45/total,'text-anchor':'middle','dominant-baseline':'middle','font-size':nominal,'font-family':this.current.font==='Serif'?'Georgia,serif':this.current.font==='Monospace'?'Courier New,monospace':'Arial,sans-serif',fill:'#132f3c'});
          text.textContent=entry.input.value;this.svg.append(text);if(entry.side!==this.side.value)text.setAttribute('visibility','hidden');
          const max=width*(item.shape==='heart'?.5:item.shape==='bone'?.48:.72);
          const measured=text.getComputedTextLength();
          if(measured>max) {
            const adjusted=nominal*max/measured;
            if(adjusted<Math.min(nominal,1.8)){wide=true;entry.input.setCustomValidity(this.copy.overflow);}
            text.setAttribute('font-size',Math.min(nominal,Math.max(1.8,adjusted)));
          }
        });
        this.blocked=wide||(!both&&backEntries.length>0);
        this.warning.hidden=!this.blocked;this.warning.textContent=!both&&backEntries.length?this.copy.cleared:this.copy.overflow;
        this.clear.hidden=both||backEntries.length===0;
        this.svg.setAttribute('aria-label',`${item.title} · ${size.label} · ${this.side.value}: ${active.map(x=>x.input.value).filter(Boolean).join(', ')}`);
      }
      review() {
        if(!this.form)return;
        const review=this.querySelector('[data-assortment-review]');review.replaceChildren();
        for(const [key,value] of new FormData(this.form)) {
          if(!key.startsWith('properties['))continue;
          const display=value instanceof File?value.name:value;if(!display)continue;
          const term=document.createElement('dt'),detail=document.createElement('dd');term.textContent=key.slice(11,-1);detail.textContent=display;review.append(term,detail);
        }
      }
    }
    customElements.define('jfab-assortment',JFabAssortment);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["engraving-lines"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jfab-engraving-lines')) {
    class JFabEngravingLines extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.form = this.closest('form');
        this.fields = this.querySelector('[data-engraving-fields]');
        this.content = this.querySelector('.engraving-lines__content');
        this.status = this.querySelector('[data-engraving-status]');
        this.error = this.querySelector('[data-engraving-error]');
        this.clear = this.querySelector('[data-engraving-clear]');
        this.svg = this.querySelector('[data-engraving-svg]');
        this.email = this.querySelector('[data-engraving-email]');
        this.copy = this.querySelector('[data-engraving-copy]').dataset;
        this.layoutName = this.querySelector('[data-engraving-layout-name]');
        this.review = this.querySelector('[data-engraving-order-review]');
        this.entries = [];
        this.controls = [];
        this.activeKey = null;
        this.blocked = false;
        try { this.layouts = JSON.parse(this.querySelector('[data-engraving-layouts]').textContent); }
        catch { this.fail(); return; }
        if (!this.form) { this.fail(); return; }
        this.form.addEventListener('change', () => queueMicrotask(() => { if (this.isConnected) this.syncLayout(); }), {signal: this.events.signal});
        this.form.addEventListener('submit', event => {
          this.syncLayout();
          this.paint();
          if (!this.hasAttribute('data-ready') || this.blocked || this.hasAttribute('data-demo')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (this.blocked) this.error.scrollIntoView({block: 'center'});
          }
        }, {capture: true, signal: this.events.signal});
        this.clear.addEventListener('click', () => {
          this.entries.splice(this.layout.lines.length);
          this.paint();
        });
        this.email.addEventListener('input', () => this.reviewOrder());
        this.syncLayout();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.initialized = false;
      }
      fail() {
        this.removeAttribute('data-ready');
        this.content.hidden = true;
        this.status.hidden = false;
        this.status.textContent = this.copy.unavailable;
        this.email.setCustomValidity(this.copy.unavailable);
      }
      selectedKey() {
        const chooser = this.form.querySelector('[data-engraving-layout-choice]');
        return chooser ? chooser.value : this.form.querySelector('[data-variant-id]')?.value;
      }
      validLayout(layout) {
        return layout && typeof layout.name === 'string' && Number.isFinite(layout.width_mm) && layout.width_mm > 0 && Number.isFinite(layout.height_mm) && layout.height_mm > 0 && Array.isArray(layout.lines) && layout.lines.length > 0 && layout.lines.length <= 50 && layout.lines.every(line => Array.isArray(line.labels) && line.labels.length > 0 && line.labels.every(label => typeof label === 'string' && label.trim()) && Number.isInteger(line.max_characters) && line.max_characters > 0);
      }
      syncLayout() {
        const key = this.selectedKey();
        if (key === this.activeKey) return;
        const layout = this.layouts[key];
        if (!this.validLayout(layout)) { this.activeKey = null; this.fail(); return; }
        this.activeKey = key;
        this.layout = layout;
        this.layoutName.value = layout.name;
        this.fields.replaceChildren();
        this.controls = [];
        layout.lines.forEach((line, index) => this.addLine(line, index));
        this.status.hidden = true;
        this.content.hidden = false;
        this.setAttribute('data-ready', '');
        this.paint();
      }
      addLine(line, index) {
        const entry = this.entries[index] || {label: '', information: ''};
        this.entries[index] = entry;
        const row = document.createElement('fieldset');
        row.className = 'engraving-lines__row';
        const legend = document.createElement('legend');
        legend.textContent = `${this.copy.line} ${index + 1}`;
        const columns = document.createElement('div');
        columns.className = 'engraving-lines__inputs';
        const labelWrap = document.createElement('label');
        labelWrap.textContent = this.copy.label;
        const select = document.createElement('select');
        select.id = `${this.dataset.instance}-engraving-label-${index}`;
        select.setAttribute('aria-label', `${legend.textContent} ${this.copy.label}`);
        select.required = true;
        const choose = new Option(this.copy.choose, '');
        choose.disabled = true;
        select.add(choose);
        select.add(new Option(this.copy.blank, '__blank__'));
        line.labels.forEach(label => select.add(new Option(label, label)));
        if (entry.label && entry.label !== '__blank__' && !line.labels.includes(entry.label)) {
          const previous = new Option(entry.label, entry.label);
          previous.disabled = true;
          select.add(previous);
        }
        select.value = entry.label;
        labelWrap.append(select);
        const valueWrap = document.createElement('label');
        valueWrap.textContent = this.copy.information;
        const input = document.createElement('input');
        input.type = 'text';
        input.id = `${this.dataset.instance}-engraving-info-${index}`;
        input.setAttribute('aria-label', `${legend.textContent} ${this.copy.information}`);
        input.autocomplete = 'off';
        input.value = entry.information;
        input.maxLength = line.max_characters;
        valueWrap.append(input);
        const property = document.createElement('input');
        property.type = 'hidden';
        property.name = `properties[Line ${index + 1}]`;
        select.addEventListener('change', () => { entry.label = select.value; this.paint(); });
        input.addEventListener('input', () => { entry.information = input.value; this.paint(); });
        columns.append(labelWrap, valueWrap);
        row.append(legend, columns, property);
        this.fields.append(row);
        this.controls.push({select, input, property, line});
      }
      svgElement(tag, attributes) {
        const element = document.createElementNS('http://www.w3.org/2000/svg', tag);
        Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
        return element;
      }
      reviewOrder() {
        this.review.replaceChildren();
        for (const [key, value] of new FormData(this.form)) {
          if (!key.startsWith('properties[') || !value) continue;
          const term = document.createElement('dt');
          const detail = document.createElement('dd');
          term.textContent = key.slice(11, -1);
          detail.textContent = value;
          this.review.append(term, detail);
        }
      }
      paint() {
        if (!this.layout || !this.hasAttribute('data-ready')) return;
        const width = this.layout.width_mm;
        const height = this.layout.height_mm;
        const count = this.layout.lines.length;
        const margin = Math.min(width, height) * 0.12;
        const pitch = (height - margin * 2) / count;
        const nominalFont = Math.min(pitch * 0.44, width * 0.035);
        const minFont = Math.max(nominalFont * 0.70, 1.8);
        const split = width * 0.40;
        const gap = width * 0.025;
        const labelWidth = split - margin - gap;
        const valueWidth = width - margin - split;
        this.svg.setAttribute('viewBox', `-2 -2 ${width+4} ${height+4}`);
        this.svg.replaceChildren();
        this.svg.append(this.svgElement('rect',{x:0,y:0,width,height,rx:1,fill:'#e5e9eb',stroke:'#435d6a','stroke-width':.4}));
        const mounting=this.dataset.mounting||'No holes';
        const hole=(x,y)=>this.svg.append(this.svgElement('circle',{cx:x,cy:y,r:Math.min(width,height)*.045,fill:'#f3f5f6',stroke:'#435d6a','stroke-width':.3,'data-mounting-hole':''}));
        if(mounting==='Two end holes'){hole(width*.07,height/2);hole(width*.93,height/2);}
        else if(mounting==='Four corner holes'){for(const x of [.07,.93])for(const y of [.14,.86])hole(width*x,height*y);}
        const summary = [];
        let invalidLine = false;
        let invalidLabel = false;
        this.controls.forEach(({select, input, property, line}, index) => {
          const entry = this.entries[index];
          const blank = entry.label === '__blank__';
          const pending = !entry.label;
          const validLabel = blank || line.labels.includes(entry.label);
          input.disabled = blank || pending;
          select.setCustomValidity(!pending && !validLabel ? this.copy.invalidLabel : '');
          invalidLabel ||= !pending && !validLabel;
          let tooWide = !validLabel && !pending;
          if (!blank && !pending && entry.information.length > line.max_characters) tooWide = true;
          const label = blank || pending ? '' : `${entry.label}:`;
          const information = blank || pending ? '' : entry.information;
          property.disabled = pending;
          property.value = blank ? this.copy.blank : `${label}${information ? ' ' + information : ''}`;
          summary.push(`${this.copy.line} ${index + 1}: ${label} ${information}`);
          const y = margin + pitch * (index + 0.5);
          const labelText = this.svgElement('text', {x: margin, y, 'dominant-baseline': 'middle', 'font-size': nominalFont});
          const valueText = this.svgElement('text', {x: split, y, 'dominant-baseline': 'middle', 'font-size': nominalFont});
          labelText.textContent = label;
          valueText.textContent = information;
          this.svg.append(labelText, valueText);
          for (const [text, available] of [[labelText, labelWidth], [valueText, valueWidth]]) {
            const measured = text.getComputedTextLength();
            if (measured > available && measured > 0) {
              const adjusted = nominalFont * available / measured;
              if (adjusted < minFont) tooWide = true;
              text.setAttribute('font-size', Math.min(nominalFont, adjusted));
            }
          }
          input.setCustomValidity(tooWide ? `${this.copy.line} ${index + 1}: ${this.copy.wide}` : '');
          invalidLine ||= tooWide;
        });
        const extra = this.entries.slice(count).some(entry => (entry.label && entry.label !== '__blank__') || (entry.information && entry.label !== '__blank__'));
        this.blocked = extra || invalidLine;
        this.error.hidden = !this.blocked;
        this.error.textContent = extra ? this.copy.overflow : invalidLabel ? this.copy.invalidLabel : invalidLine ? this.copy.wide : '';
        this.clear.hidden = !extra;
        this.email.setCustomValidity(this.blocked ? this.error.textContent : '');
        this.svg.setAttribute('aria-label', summary.join('. '));
        this.reviewOrder();
      }
    }
    customElements.define('jfab-engraving-lines', JFabEngravingLines);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jfab-engraving-gift-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jfab-engraving-gift')) {
    class JFabEngravingGift extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.closest('form');
        this.mode = this.querySelector('[data-gift-mode]');
        this.text = this.querySelector('[data-gift-text]');
        this.file = this.querySelector('[data-gift-file]');
        this.count = this.querySelector('[data-gift-count]');
        this.variants = JSON.parse(this.querySelector('[data-gift-variants]').textContent);
        this.copy = JSON.parse(this.querySelector('[data-gift-copy]').textContent);
        this.sync = this.sync.bind(this);
        this.form.addEventListener('input', this.sync);
        this.form.addEventListener('change', this.sync);
        this.onSubmit = event => {
          this.sync();
          if (!this.form.reportValidity()) event.preventDefault();
        };
        this.form.addEventListener('submit', this.onSubmit);
        this.sync();
      }
      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('input', this.sync);
        this.form.removeEventListener('change', this.sync);
        this.form.removeEventListener('submit', this.onSubmit);
        this.initialized = false;
      }
      sync() {
        const logo = this.mode.value === 'Same logo on every item';
        const individual = this.mode.value === 'Individual names';
        this.querySelector('[data-gift-text-wrap]').hidden = logo;
        this.querySelector('[data-gift-file-wrap]').hidden = !logo;
        this.text.disabled = logo;
        this.text.required = !logo;
        this.file.disabled = !logo;
        this.file.required = logo;
        const variantId = this.form.querySelector('[name="id"]').value;
        const packSelect = this.form.querySelector('[data-option-name="Pack quantity"]');
        const pack = this.dataset.giftFlask === 'true' && packSelect ? Number(packSelect.value) : this.variants[variantId] || 1;
        const quantity = Number(this.form.querySelector('[name="quantity"]').value);
        const total = pack * quantity;
        const lines = this.text.value.split(/\r?\n/).filter(line => line.trim());
        const validQuantity = Number.isInteger(quantity) && quantity > 0;
        this.count.textContent = individual && validQuantity ? this.copy.count.replace('[count]', String(total)) : '';
        this.text.setCustomValidity(individual && validQuantity && lines.length !== total ? this.copy.count_error.replace('[count]', String(total)) : '');
      }
    }
    customElements.define('jfab-engraving-gift', JFabEngravingGift);
  }
  } catch(e) { console.error(e); }
})();

})();
